import { TopListProps, TopListSize } from './types'
import { useTranslation } from 'react-i18next'
import find from 'lodash/find'
import { useState } from 'react'
import * as React from 'react'
import { ToplistItem } from '../../Shared/Services/Campaign/interfaces'
import Button from '@sharedComponents/Button/Button'
import { ButtonType } from '@sharedComponents/Button/types'
import './Scss/top-list.scss'

const TopList = (props: TopListProps) => {
    const { t } = useTranslation()
    const [size, setSize] = useState<number>(TopListSize.Default)

    const noResults = !!(!props.items || props.items.length === 0)

    const onToggleSize = () => {
        setSize(
            size === TopListSize.Default
                ? TopListSize.Expanded
                : TopListSize.Default
        )
    }

    const renderSeparator = () => {
        if (
            find(
                props.ownItems,
                (item: ToplistItem) =>
                    (props.useGlobalTopList
                        ? item.position
                        : item.positionCounty) > size
            )
        ) {
            return (
                <div className='separator-wrapper'>
                    <div className='separator-wrapper__separator' />
                </div>
            )
        }
        return <></>
    }

    const renderOwnItems = () => {
        return props.ownItems.map((ownItem: ToplistItem, index) => {
            if (
                (props.useGlobalTopList
                    ? ownItem.position
                    : ownItem.positionCounty) > size &&
                index <= size
            ) {
                return (
                    <div key={ownItem.id} className="top-list-item top-list-item__own">
                        <span className="top-list-item__name">{`${
                            props.useGlobalTopList
                                ? ownItem.position
                                : ownItem.positionCounty
                        }. ${ownItem.name}`}</span>
                        <span className="top-list-count">{`${ownItem.numberOfItemsFormatted}`}</span>
                    </div>
                )
            }
            return null
        })
    }

    return (
        <div>
            <div className='top-list-head'>
                <span>{t('campaign.place')}</span>
                <span>{t('campaign.count')}</span>
            </div>
            {noResults && (
                <div className='top-list-no-result'>
                    {t('campaign.noResults')}
                </div>
            )}
            {props.items.map((item: ToplistItem, index) => {
                if (props.isSearched || index < size) {
                    const isOwn = find(props.ownItems, { id: item.id })
                    return (
                        <div
                            key={item.id}
                            className={`top-list-item ${isOwn ? 'top-list-item__own' : ''}`}
                        >
                            <span className="top-list-item__name">{`${
                                props.useGlobalTopList
                                    ? item.position
                                    : item.positionCounty
                            }. ${item.name}`}</span>
                            <span className="top-list-item__count">{`${item.numberOfItemsFormatted}`}</span>
                        </div>
                    )
                }
                return null
            })}
            {!props.isSearched && props.ownItems && props.ownItems.length > 0 && (
                <>
                    {renderSeparator()}
                    {renderOwnItems()}
                </>
            )}
            {!props.isSearched && props.items?.length > 0 && (
                <div className='top-list-button-wrapper'>
                    <Button
                        type={ButtonType.PRIMARY_ALT}
                        text={
                            size === TopListSize.Default
                                ? t('campaign.showAll')
                                : t('campaign.show10')
                        }
                        onClick={onToggleSize}
                    />
                </div>
            )}
        </div>
    )
}

export default TopList